import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const BaseModal = ({
  open,
  onCancelCb = () => null,
  onConfirmCb = () => null,
  setOpen,
  modalTitle,
  modalDescribedBy,
  title,
  text,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  cancelOnly = false,
  children,
}) => (
  <Modal
    open={open}
    onClose={() => {
      onCancelCb();
      setOpen(false);
    }}
    aria-labelledby={modalTitle || title}
    aria-describedby={modalDescribedBy}
  >
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: window.innerWidth < 400 ? "100%" : 550,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        overflowY: "auto",
        borderRadius: "0.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <MDTypography
          sx={{ marginBottom: "1rem" }}
          id={modalTitle || title}
          variant="h5"
          component="h2"
        >
          {title}
        </MDTypography>
      </Box>
      <Typography id={modalDescribedBy} sx={{ mt: 2, marginBottom: "1rem" }}>
        {text}
      </Typography>
      {children}
      <MDBox sx={{ display: "flex", justifyContent: "flex-end" }}>
        <MDBox>
          <MDButton
            color="gray80"
            onClick={() => {
              onCancelCb();
              setOpen(false);
            }}
            sx={{ mt: 2, mr: 1, position: "relative" }}
          >
            {cancelLabel}
          </MDButton>
          {!cancelOnly && (
            <MDButton
              color="primaryRed"
              onClick={() => {
                onConfirmCb();
                setOpen(false);
              }}
              sx={{ mt: 2, mr: 1, position: "relative" }}
            >
              {confirmLabel}
            </MDButton>
          )}
        </MDBox>
      </MDBox>
    </Box>
  </Modal>
);

export default BaseModal;
